import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-8" }
const _hoisted_2 = {
  key: 0,
  class: "w-full flex flex-col items-center justify-center mx-auto"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "w-36 h-36 rounded-lg border border-white mx-auto"
}
const _hoisted_5 = {
  key: 0,
  class: "h-screen"
}
const _hoisted_6 = { class: "w-full text-gray-600 px-0 mx-auto flex justify-center" }
const _hoisted_7 = { class: "w-full space-y-4 pb-5" }
const _hoisted_8 = { class: "mx-auto block w-full" }
const _hoisted_9 = { class: "relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5 mt-3" }
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_12 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_13 = { class: "text-sm text-red-500 p-error" }
const _hoisted_14 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_15 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_16 = { class: "text-sm text-red-500 p-error" }
const _hoisted_17 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_18 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_19 = { class: "text-sm text-red-500 p-error" }
const _hoisted_20 = { class: "relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5 mt-3" }
const _hoisted_21 = { class: "w-full" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["tag"]
const _hoisted_24 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_25 = { class: "w-full px-2" }
const _hoisted_26 = { class: "block mb-1" }
const _hoisted_27 = { class: "relative w-full shadow-lg rounded-lg bg-white px-4 py-1 mt-3" }
const _hoisted_28 = { class: "w-full" }
const _hoisted_29 = { class: "flex flex-col md:flex-row my-2 gap-2 mt-2" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_32 = { class: "pi pi-check mr-2" }
const _hoisted_33 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_CommonPrivateView = _resolveComponent("CommonPrivateView")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_ModalFileUpload = _resolveComponent("ModalFileUpload")!
  const _component_CropperView = _resolveComponent("CropperView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CommonPrivateView, null, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.empresaProducto)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_ctx.empresaProducto.previewFotoFile)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.empresaProducto.previewFotoFile,
                      class: "w-auto h-36 rounded-lg border border-white mx-auto"
                    }, null, 8, _hoisted_3))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4)),
                (_ctx.empresaProducto)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isFileUploadVisible = true)),
                      class: "cursor-pointer mt-3 py-2 px-4 block rounded-lg border border-white bg-transparent text-white hover:bg-black hover:text-white"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'upload'] }),
                      _cache[6] || (_cache[6] = _createTextVNode(" SUBIR FOTO "))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      content: _withCtx(() => [
        (!_ctx.empresaProducto)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Cargando..."))
          : _createCommentVNode("", true),
        (_ctx.empresaProducto)
          ? (_openBlock(), _createBlock(_component_Form, {
              key: 1,
              onSubmit: _ctx.onSubmit,
              class: "w-full",
              "validation-schema": _ctx.schema,
              onInvalidSubmit: _ctx.onInvalidSubmit
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex items-center justify-between font-semibold text-lg" }, " PRODUCTO ", -1)),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block mb-1" }, "Descripción", -1)),
                              _createVNode(_component_Field, {
                                name: "descripcion",
                                modelValue: _ctx.empresaProducto.descripcion,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.empresaProducto.descripcion) = $event))
                              }, {
                                default: _withCtx(({ field, errors }) => [
                                  _createVNode(_component_InputText, _mergeProps(field, {
                                    type: "text",
                                    placeholder: "Descripcion",
                                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                                  }), null, 16, ["class"]),
                                  _createElementVNode("span", _hoisted_13, [
                                    _createVNode(_component_ErrorMessage, { name: "descripcion" })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block mb-1" }, "Detalles", -1)),
                              _createVNode(_component_Field, {
                                name: "detalles",
                                modelValue: _ctx.empresaProducto.detalles,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.empresaProducto.detalles) = $event))
                              }, {
                                default: _withCtx(({ field, errors }) => [
                                  _createVNode(_component_Textarea, _mergeProps({ rows: "4" }, field, {
                                    type: "text",
                                    placeholder: "Breve descripción del producto",
                                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                                  }), null, 16, ["class"]),
                                  _createElementVNode("span", _hoisted_16, [
                                    _createVNode(_component_ErrorMessage, { name: "detalles" })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block mb-1" }, "Orden", -1)),
                              _createVNode(_component_Field, {
                                name: "orden",
                                modelValue: _ctx.empresaProducto.orden,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.empresaProducto.orden) = $event))
                              }, {
                                default: _withCtx(({ field, errors }) => [
                                  _createVNode(_component_InputText, _mergeProps(field, {
                                    type: "numeric",
                                    placeholder: "Orden",
                                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                                  }), null, 16, ["class"]),
                                  _createElementVNode("span", _hoisted_19, [
                                    _createVNode(_component_ErrorMessage, { name: "orden" })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "flex items-center justify-between font-semibold text-lg" }, " CATEGORÍAS ", -1)),
                        _createElementVNode("div", _hoisted_21, [
                          (_ctx.tags)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: tag.id,
                                    tag: tag
                                  }, [
                                    _createElementVNode("div", _hoisted_24, [
                                      _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("label", _hoisted_26, _toDisplayString(tag.descripcion), 1),
                                        _createVNode(_component_Field, {
                                          name: `tag-${tag.id}`
                                        }, {
                                          default: _withCtx(({ errors }) => [
                                            _createVNode(_component_MultiSelect, {
                                              "model-value": tag.opcionesTagSeleccionados,
                                              "onUpdate:modelValue": val => tag.opcionesTagSeleccionados = val,
                                              options: tag.opciones,
                                              optionLabel: "descripcion",
                                              optionValue: "id",
                                              filter: "",
                                              placeholder: tag.descripcion,
                                              class: _normalizeClass(["input-base", {'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && tag.opcionesTagSeleccionados?.length > 0, 'input-error': errors.length > 0 }])
                                            }, null, 8, ["model-value", "onUpdate:modelValue", "options", "placeholder", "class"])
                                          ]),
                                          _: 2
                                        }, 1032, ["name"])
                                      ])
                                    ])
                                  ], 8, _hoisted_23))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("button", {
                              type: "submit",
                              class: "px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
                              disabled: _ctx.isSubmitting
                            }, [
                              _withDirectives(_createElementVNode("i", _hoisted_31, null, 512), [
                                [_vShow, _ctx.isSubmitting]
                              ]),
                              _withDirectives(_createElementVNode("i", _hoisted_32, null, 512), [
                                [_vShow, !_ctx.isSubmitting]
                              ]),
                              _cache[12] || (_cache[12] = _createTextVNode("ACEPTAR "))
                            ], 8, _hoisted_30),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelarModificacion && _ctx.cancelarModificacion(...args))),
                              class: "px-4 py-2 bg-transparent border-red-700 hover:bg-red-700 text-red-700 font-semibold hover:text-white border rounded",
                              disabled: _ctx.isSubmitting
                            }, _cache[13] || (_cache[13] = [
                              _createElementVNode("i", { class: "pi pi-times mr-2" }, null, -1),
                              _createTextVNode("CANCELAR ")
                            ]), 8, _hoisted_33)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_BlockUI, {
      blocked: _ctx.isSubmitting,
      fullScreen: ""
    }, null, 8, ["blocked"]),
    _createVNode(_component_ModalFileUpload, {
      visible: _ctx.isFileUploadVisible,
      askDescription: false,
      forceSquare: false,
      maxSizeMB: 2,
      fileTypes: ['image/png', 'image/jpg', 'image/jpeg'],
      onAccept: _ctx.onFileUploadAcepted,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isFileUploadVisible = $event))
    }, null, 8, ["visible", "onAccept"]),
    (_ctx.showCropper)
      ? (_openBlock(), _createBlock(_component_CropperView, {
          key: 0,
          image: _ctx.beforeCropBase64,
          onClose: _ctx.onCropFinished
        }, null, 8, ["image", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}